import QuestionInputSelectMulti from "./QuestionInputSelectMulti";

export default class QuestionInputSelectMultiGraph extends QuestionInputSelectMulti {
    constructor(question, view) {
        super(question, view);

        this._view.hideInputField();
    }

    selectOption(option) {
        if (this._selected.length < 2) {
            option.alpha = 0.5;

            this._selected.push(option.value);
            this._view.setAnswer(this._selected);
        }
    }
}